class TransactionMapper {
  static createFromResponse(response) {
    return {
      orderReference: response.order_reference,
      orderDate: response.order_date,
      totalPrice: response.total_price,
      type: response.type,
      currency: response.currency
    };
  }
  static createTransactionsFromResponse(response) {
    return {
      items: response.items.map(this.createFromResponse),
      pagination: {
        currentPage: response.pagination.current_page,
        totalPages: response.pagination.total_pages,
        totalElements: response.pagination.total_registers
      }
    };
  }
}

export { TransactionMapper };
//# sourceMappingURL=TransactionMapper.js.map
